import React from 'react';
import {UNSET_DEFAULT_TEAM} from 'services/customActions';
import StandardButton from 'components/StandardButton';
import {withDataProvider} from 'react-admin';
import {getUserInfo} from 'utils/Data';
import {refreshView, translate} from 'ra-core';
import compose from 'recompose/compose';
import {connect} from 'react-redux';

const UnsetDefaultTeam = props => {
	if ( !getUserInfo().isSuper ) {
		return null;
	}

	const handleClick = e => {
		if (e) e.stopPropagation();
		props.onClick && props.onClick(e);
		var id = "";

		unsetDefaultTeam({id});
	};

	const unsetDefaultTeam = async values => {
		const {dataProvider, refreshView} = props;
		dataProvider(
			UNSET_DEFAULT_TEAM,
			'config',
			{},
			{
				onSuccess: {
					refresh: true,
					unselectAll: true,
				},
				onFailure: {
					unselectAll: true,
					notification: {level: 'warning'},
				},
			}
		).then(response => {
			let runwayOrgConfig = sessionStorage.getItem('runwayOrgConfig');

			if (runwayOrgConfig) {
				runwayOrgConfig = JSON.parse(runwayOrgConfig);
				runwayOrgConfig['config']['defaultTeamId'] = response.data.id;
				sessionStorage.setItem(
					'runwayOrgConfig',
					JSON.stringify(runwayOrgConfig)
				);
			}
		});
		refreshView();
	};

	return (
		<StandardButton
			onClick={handleClick}
			variant='link'
			label='Unset Default Team'
		/>
	);
};

function mapStateToProps(state) {
	return {
		form: state.form,
	};
}

const mapDispatchToProps = {
	refreshView,
};

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	translate,
	withDataProvider
);
export default enhance(UnsetDefaultTeam);
